var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{staticClass:"close-button",attrs:{"radius":"","color":"danger","type":"filled","icon":"close","size":"large"},on:{"click":function($event){return _vm.$emit('close', 'close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }